






























































































































































































































































































































































































































































import {
  defineNuxtComponent,
  PropType,
  computed
} from '~/utils/nuxt3-migration'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS } from '~/store/modules/shared/user/state'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import ClassifiedSearchResultsRowPromoRibbon from '~/components/car/classifieds/search/results/ClassifiedSearchResultsRowPromoRibbon.vue'
import { ciCheckCircle } from '~/icons/source/light/check-circle'
import { ciAngleRight as ciAngleRightRegular } from '~/icons/source/regular/angle-right'
import { ciAngleRight as ciAngleRightSolid } from '~/icons/source/solid/angle-right'
import { ciClock } from '~/icons/source/regular/clock'
import { ciLocationPin } from '~/icons/source/regular/location-pin'
import { ciAngleLeft } from '~/icons/source/solid/angle-left'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/favorite/CClassifiedFavoriteButton.vue'
import CClassifiedCompareButton from '~/components/shared/configurable/classified/compare/CClassifiedCompareButton.vue'
import { MODIFY_ROW_PARKED } from '~/store/modules/shared/classifieds/search/mutation-types'
import ClassifiedSearchResultsRowCensoredOverlay from '~/components/car/classifieds/search/results/ClassifiedSearchResultsRowCensoredOverlay.vue'
import { useClassifiedSearchResultRow } from '~/compositions/classified-search/useClassifiedSearchResultRow'
import ClassifiedSearchResultsRowActions from '~/components/car/classifieds/search/results/ClassifiedSearchResultsRowActions.vue'
import PaidClassifiedInfo from '~/components/car/classifieds/search/results/rows/main/partials/PaidInfo/PaidClassifiedInfo.vue'
import { ciCamera } from '~/icons/source/regular/camera'
import { ciYoutube } from '~/icons/source/solid/youtube'
import ClassifiedSearchResultsRowBadges from '~/components/car/classifieds/search/results/ClassifiedSearchResultsRowBadges.vue'
import { ClassifiedSearchResultRow } from '~/models/search/types'

export default defineNuxtComponent({
  components: {
    ClassifiedSearchResultsRowBadges,
    ClassifiedSearchResultsRowCensoredOverlay,
    ClassifiedSearchResultsRowPromoRibbon,
    ClassifiedSearchResultsRowActions,
    CClassifiedCompareButton,
    CClassifiedFavoriteButton,
    CPrice,
    PaidClassifiedInfo
  },
  props: {
    classified: {
      type: Object as PropType<ClassifiedSearchResultRow>,
      required: true
    },
    lazyLoadImage: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { getters: userGetters } = useNamespacedStore(USER_NS)
    const { commit: classifiedSearchCommit } = useNamespacedStore(
      CLASSIFIED_SEARCH_NS
    )
    const {
      isPartClassified,
      isXymaClassified,
      isRentalClassified,
      isPromoted,
      isCensored,
      isTouchingImage,
      showSellerInfo,
      rootCategoryId,
      rowBgClass,
      href,
      classifiedRequiresPayment,
      classifiedBackgroundJobs,
      classifiedImgContainerClass,
      showActions,
      images,
      currentImageIndex,
      imageLoading,
      classifiedImg,
      showCompareButton,
      lastModifiedDate,
      onRowClick,
      onMessageClick,
      onSetActivePromotion,
      getKeyFeatureIcon,
      loadPreviousImage,
      loadNextImage,
      onImageTouchStart,
      onImageTouchEnd
    } = useClassifiedSearchResultRow(props.classified)

    const userIsManager = computed(() => userGetters('isManager'))

    function onParked(isParked: boolean) {
      classifiedSearchCommit(MODIFY_ROW_PARKED, {
        classifiedId: props.classified.id,
        parked: isParked
      })
    }

    return {
      ciCheckCircle,
      ciAngleRightRegular,
      ciAngleRightSolid,
      ciClock,
      ciLocationPin,
      ciAngleLeft,
      ciCamera,
      ciYoutube,
      isTouchingImage,
      currentImageIndex,
      href,
      imageLoading,
      classifiedImg,
      lastModifiedDate,
      userIsManager,
      isPromoted,
      rowBgClass,
      showSellerInfo,
      isPartClassified,
      showCompareButton,
      rootCategoryId,
      isCensored,
      isXymaClassified,
      isRentalClassified,
      showActions,
      classifiedRequiresPayment,
      classifiedImgContainerClass,
      classifiedBackgroundJobs,
      images,
      onParked,
      getKeyFeatureIcon,
      onRowClick,
      onMessageClick,
      onSetActivePromotion,
      loadPreviousImage,
      loadNextImage,
      onImageTouchStart,
      onImageTouchEnd
    }
  },
  i18n: defineComponentTranslations({
    leasing_option: {
      en: '/ month for {months}, {mileage} Km / year',
      el: '/ μήνα για {months}, {mileage} Km / έτος'
    },
    lease_downpayment: {
      en: 'downpayment {downpayment} € + VAT',
      el: 'προκαταβολή {downpayment} € + ΦΠΑ'
    },
    months: {
      en: '1 month | {count} months',
      el: '1 μήνα | {count} μήνες'
    }
  })
})
